import React, { useState } from "react";
import { Link } from "react-router-dom";


export default function Config() {


  // Depois substituir pelo retorno da API
  const usuario = {
    nome: "",
    email: "",
    empresa: "",
    plano: "",
    status: "",
    renovacao: ""
  };


  const [senhaAtual, setSenhaAtual] = useState("");
  const [novaSenha, setNovaSenha] = useState("");
  const [confirmarSenha, setConfirmarSenha] = useState("");

  const [mensagem, setMensagem] = useState("");
  const [tipoMensagem, setTipoMensagem] = useState("");



  function validarSenha(){

    if(novaSenha.length < 8){
      return "A senha deve possuir no mínimo 8 caracteres";
    }


    if(!/[A-Z]/.test(novaSenha)){
      return "A senha deve possuir uma letra maiúscula";
    }


    if(!/[a-z]/.test(novaSenha)){
      return "A senha deve possuir uma letra minúscula";
    }


    if(!/[0-9]/.test(novaSenha)){
      return "A senha deve possuir um número";
    }


    if(!/[!@#$%^&*]/.test(novaSenha)){
      return "A senha deve possuir um caractere especial";
    }


    if(novaSenha !== confirmarSenha){
      return "As senhas não conferem";
    }


    return null;

  }



  function alterarSenha(){


    const erro = validarSenha();


    if(erro){

      setMensagem(erro);
      setTipoMensagem("erro");

      return;

    }



    /*
      Aqui futuramente:

      api.post("/auth/alterarSenha.php",{
        senhaAtual,
        novaSenha
      })

    */


    setMensagem("Senha alterada com sucesso.");
    setTipoMensagem("sucesso");


    setSenhaAtual("");
    setNovaSenha("");
    setConfirmarSenha("");

  }




  return (

    <div className="space-y-8">


      {/* Cabeçalho */}

      <div>

        <h1 className="text-3xl font-bold text-text-primary">
          Configurações
        </h1>


        <p className="text-text-secondary mt-2">
          Gerencie sua conta, assinatura e segurança.
        </p>


      </div>





      {/* Dados da conta */}

      <section className="bg-white rounded-card border border-border shadow-sm p-6">


        <h2 className="text-xl font-semibold mb-6">
          Dados da Conta
        </h2>



        <div className="grid md:grid-cols-2 gap-5">


          <div>

            <label className="text-sm text-text-secondary">
              Nome
            </label>


            <input

              disabled

              value={usuario.nome}

              placeholder="Nome cadastrado"

              className="
              w-full
              mt-1
              border
              rounded-lg
              p-3
              bg-gray-100
              "

            />


          </div>



          <div>


            <label className="text-sm text-text-secondary">
              Email
            </label>


            <input

              disabled

              value={usuario.email}

              placeholder="Email cadastrado"

              className="
              w-full
              mt-1
              border
              rounded-lg
              p-3
              bg-gray-100
              "

            />


          </div>




          <div>


            <label className="text-sm text-text-secondary">
              Empresa
            </label>


            <input

              disabled

              value={usuario.empresa}

              placeholder="Empresa cadastrada"

              className="
              w-full
              mt-1
              border
              rounded-lg
              p-3
              bg-gray-100
              "

            />


          </div>


        </div>



        <div className="
          mt-5
          bg-yellow-50
          border
          border-yellow-200
          rounded-lg
          p-4
        ">


          <p className="text-sm text-yellow-800">


            Os dados cadastrais não podem ser alterados pelo usuário.


            Para alteração de nome, empresa ou e-mail,
            entre em contato com o administrador.


          </p>


        </div>


      </section>







      {/* Plano */}

      <section className="bg-white rounded-card border border-border shadow-sm p-6">


        <h2 className="text-xl font-semibold mb-6">
          Assinatura
        </h2>



        <div className="grid md:grid-cols-3 gap-5">



          <div>

            <label className="text-sm text-text-secondary">
              Plano contratado
            </label>


            <input

              disabled

              value={usuario.plano}

              placeholder="Plano"

              className="
              w-full
              mt-1
              border
              rounded-lg
              p-3
              bg-gray-100
              "

            />


          </div>




          <div>

            <label className="text-sm text-text-secondary">
              Status da conta
            </label>


            <div className="mt-3">


              <span className="
              px-4
              py-2
              rounded-full
              bg-green-100
              text-green-700
              font-semibold
              ">


                {usuario.status || "Carregando..."}


              </span>


            </div>


          </div>





          <div>


            <label className="text-sm text-text-secondary">
              Próxima renovação
            </label>


            <input

              disabled

              value={usuario.renovacao}

              placeholder="Data renovação"

              className="
              w-full
              mt-1
              border
              rounded-lg
              p-3
              bg-gray-100
              "

            />


          </div>



        </div>


      </section>








      {/* Segurança */}

      <section className="bg-white rounded-card border border-border shadow-sm p-6">


        <h2 className="text-xl font-semibold mb-6">
          Segurança
        </h2>



        <div className="space-y-4">



          <input

            type="password"

            placeholder="Senha atual"

            value={senhaAtual}

            onChange={(e)=>setSenhaAtual(e.target.value)}

            className="w-full border rounded-lg p-3"

          />



          <input

            type="password"

            placeholder="Nova senha"

            value={novaSenha}

            onChange={(e)=>setNovaSenha(e.target.value)}

            className="w-full border rounded-lg p-3"

          />




          <input

            type="password"

            placeholder="Confirmar nova senha"

            value={confirmarSenha}

            onChange={(e)=>setConfirmarSenha(e.target.value)}

            className="w-full border rounded-lg p-3"

          />





          <div className="
          bg-blue-50
          border
          border-blue-200
          rounded-lg
          p-4
          ">


            <p className="text-sm font-semibold">

              Critérios de segurança:

            </p>


            <ul className="list-disc ml-5 mt-2 text-sm">


              <li>Mínimo 8 caracteres</li>

              <li>Uma letra maiúscula</li>

              <li>Uma letra minúscula</li>

              <li>Um número</li>

              <li>Um caractere especial</li>


            </ul>


          </div>





          <button

            onClick={alterarSenha}

            className="
            bg-primary
            text-white
            px-5
            py-3
            rounded-lg
            hover:opacity-90
            "

          >

            Alterar Senha

          </button>





          {
            mensagem && (

              <div
                className={`
                p-4
                rounded-lg
                ${
                  tipoMensagem === "sucesso"
                  ?
                  "bg-green-50 text-green-700"
                  :
                  "bg-red-50 text-red-700"
                }
                `}
              >

                {mensagem}

              </div>

            )
          }



        </div>


      </section>








      <div className="flex justify-end">


        <Link

          to="/dashboard"

          className="
          bg-primary
          text-white
          px-6
          py-3
          rounded-lg
          "

        >

          Voltar ao Dashboard


        </Link>


      </div>



    </div>


  );


}